import React from 'react';
import Avatar from '../utils/Avatar';
import '../styles/loadingAvatar.css';

const LoadingAvatar = ({avatar, voice, configuration}) => {
    return (
        <div className="loading-avatar-container">
            <div className="loading-avatar-indicator">
                <div className="loading-avatar-spinner" />
                {avatar && (
                    <div
                        style={{backgroundImage: Avatar({avatar, voice, configuration})}}
                        className="loading-avatar-img loading-avatar-index"
                    />
                )}
            </div>
        </div>
    );
};

export default LoadingAvatar;
